import { View, Text, StyleSheet, Pressable } from "react-native";
import { screenWidth } from "../../platform";
import { COLORS } from "../../theme/colors";
import { STRINGS } from "../../constants/strings";

const AlertMessage = ({ message, showAlert, okOnPress, closeOnPress }) => {
  if (!showAlert) return null;

  return (
    <View style={styles.container}>
      <View style={styles.box}>
        <Text style={styles.messageText} maxFontSizeMultiplier={1.2}>
          {message}
        </Text>
        <View style={styles.buttonContainer}>
          <Pressable
            style={styles.button}
            onPress={okOnPress}
            testID="ok-button"
            accessible={true}
            accessibilityRole="button"
            accessibilityLabel="OK button"
          >
            <Text style={styles.buttonText} maxFontSizeMultiplier={1.2}>
              {STRINGS.ok}
            </Text>
          </Pressable>
          <Pressable
            style={styles.button}
            onPress={closeOnPress}
            testID="cancel-button"
            accessible={true}
            accessibilityRole="button"
            accessibilityLabel="Cancel button"
          >
            <Text style={styles.buttonText} maxFontSizeMultiplier={1.2}>
              {STRINGS.cancel}
            </Text>
          </Pressable>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: COLORS.secondaryTranslucent,
    zIndex: 1000,
  },
  box: {
    backgroundColor: COLORS.background,
    borderRadius: 8,
    borderWidth: 1,
    padding: 20,
    width: screenWidth > 500 ? 500 : "90%",
    minHeight: 100,
  },
  messageText: {
    fontSize: 18,
    marginBottom: 20,
  },
  buttonContainer: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 20,
    gap: 10,
  },
  button: {
    backgroundColor: COLORS.red,
    paddingVertical: 10,
    paddingHorizontal: 5,
    borderRadius: 25,
    minWidth: 100,
  },
  buttonText: {
    color: COLORS.textLight,
    fontSize: 18,
    textAlign: "center",
  },
});

export default AlertMessage;
